import PageHero from "../components/PageHero";

const SERVICES = [
  {
    icon: "ri-home-4-line",
    title: "Villa Design & Architecture",
    desc: "Premium A-frame villa designs with 8ft wall bases, nature-centric layouts and scalable configurations tailored to your site and investment goals.",
    points: ["A-frame structure", "8ft wall comfort", "Nature integration"],
  },
  {
    icon: "ri-hammer-line",
    title: "Modular Construction",
    desc: "Precision factory-fabricated modules delivered and assembled on-site — up to 60% faster than traditional construction with superior quality control.",
    points: ["Factory precision", "Fast installation", "Reduced waste"],
  },
  {
    icon: "ri-hotel-line",
    title: "Resort Management",
    desc: "End-to-end hospitality operations including guest services, housekeeping, maintenance and revenue management so you earn passively.",
    points: ["Guest experience", "Operations team", "Revenue optimization"],
  },
  {
    icon: "ri-megaphone-line",
    title: "Marketing & Bookings",
    desc: "Multi-channel presence across Airbnb, Booking.com and direct bookings with professional photography, pricing strategy and brand positioning.",
    points: ["Airbnb & OTAs", "Dynamic pricing", "Brand building"],
  },
  {
    icon: "ri-paint-brush-line",
    title: "Interior Fit-Out & Customization",
    desc: "Fully furnished interiors with premium finishes, smart home readiness and customizable layouts to match your vision and target guests.",
    points: ["Premium furnishings", "Smart home ready", "Custom layouts"],
  },
  {
    icon: "ri-shield-check-line",
    title: "Legal & Compliance Desk",
    desc: "Title verification, permits, approvals and regulatory compliance handled by our in-house team so your investment is secure from day one.",
    points: ["Title due diligence", "Approvals & permits", "Regulatory compliance"],
  },
];

export default function Services() {
  return (
    <div className="w-full">
      <PageHero
        eyebrow="Services"
        title={
          <>
            Services for <span className="italic text-accent-300">Villa Investors</span>
          </>
        }
        subtitle="From design and modular construction to resort management and bookings — a complete hospitality investment service suite backed by 15+ years of real estate expertise."
      />

      <section className="w-full py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {SERVICES.map((s) => (
              <div
                key={s.title}
                className="rounded-2xl bg-background-100 border border-background-200 p-6 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300"
              >
                <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-primary-100 text-primary-700">
                  <i className={`${s.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-xl text-foreground-950 mt-5">{s.title}</h3>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">{s.desc}</p>
                <ul className="mt-5 space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-foreground-800">
                      <i className="ri-check-line text-accent-500"></i> {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-14 rounded-2xl bg-primary-800 text-background-100 p-6 md:p-10 text-center">
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-accent-500 text-background-50 mx-auto">
              <i className="ri-phone-fill text-2xl"></i>
            </span>
            <h3 className="font-heading text-2xl md:text-3xl text-background-50 mt-4">
              Not sure which villa type fits your goals?
            </h3>
            <p className="text-background-200/90 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              Book a free consultation. Our advisors will assess your investment profile and recommend the best villa configuration and revenue model.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/contact"
                className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-6 py-3 hover:bg-accent-600 transition-colors"
              >
                Get a Free Consultation <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="tel:8088330330"
                className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-background-50/40 text-background-50 px-6 py-3 hover:bg-background-50 hover:text-primary-800 transition-colors"
              >
                <i className="ri-phone-fill"></i> 80883 30330
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}